/**
 * 날짜 도구 (기반 공사 5단계): 쉬는 날이면 다음 평일, 체류 만료 표시.
 * 날짜는 모두 YYYY-MM-DD 글자로 주고받는다(한국 날짜, CODE_RULES 7절). 공휴일 목록은 부르는 쪽이 넘긴다.
 */

/** 날짜에 일수를 더한다. */
export function addDays(day: string, n: number): string {
  const t = Date.parse(`${day}T00:00:00Z`) + n * 86_400_000;
  return new Date(t).toISOString().slice(0, 10);
}

/** b - a 일수 */
export function daysBetween(a: string, b: string): number {
  return Math.round((Date.parse(`${b}T00:00:00Z`) - Date.parse(`${a}T00:00:00Z`)) / 86_400_000);
}

/** 토요일, 일요일 */
export function isWeekend(day: string): boolean {
  const w = new Date(`${day}T00:00:00Z`).getUTCDay();
  return w === 0 || w === 6;
}

/** 쉬는 날(주말이나 공휴일)이면 다음 평일로 옮긴다(기능/10 "쉬는 날이면 다음 평일로"). 평일이면 그대로. */
export function nextBusinessDay(day: string, holidays: ReadonlySet<string>): string {
  let d = day;
  for (let i = 0; i < 31 && (isWeekend(d) || holidays.has(d)); i++) d = addDays(d, 1);
  return d;
}

/** 체류 만료 미리 알림을 시작하는 날수(공통/데이터원칙 0-7: 만료 30일 전) */
export const VISA_NOTICE_DAYS = 30;

export interface VisaBadge {
  /** 이름 옆 둥근 알약 칸에 적는 말 */
  text: string;
  /** 인력 관리 목록 맨 위로 올릴지 */
  pin_top: boolean;
}

/**
 * 체류 만료 표시 (기능/06 "체류 만료 표시", 2026-11-02, 2026-11-04 대표님)
 * - 만료 30일 전부터 만료일까지: 목록 맨 위, "체류 만료 D-12"(만료일 당일은 D-0)
 * - 만료일이 지나면: 원래 자리, "체류 만료됨". 무엇을 하라는 안내는 하지 않는다.
 * - 그보다 이르거나 만료일이 없으면 표시 없음
 */
export function visaBadge(visa_until: string | null, today: string): VisaBadge | null {
  if (!visa_until) return null;
  const left = daysBetween(today, visa_until);
  if (left < 0) return { text: '체류 만료됨', pin_top: false };
  if (left <= VISA_NOTICE_DAYS) return { text: `체류 만료 D-${left}`, pin_top: true };
  return null;
}
